// JavaScript Document
//components/configuration/ConfigStandard.js
import React from 'react';



export default function Display(props) {
  	//const classes = useStyles();
  	const {id, path, width, height, displayState, pixel_map, timing, scale, splitVertical, borderSize} = props;
	const [msgid, setMsgid] = React.useState(0);
	const [imgpath, setImgpath] = React.useState('/needs/vspeedOnline/sign-data/pixel_messages/');
	const [size, setSize] = React.useState([30, 18]);
	const [scaling, setScaling] = React.useState(2);
	const [isOn, setIsOn] = React.useState(true);
	const [flashing, setFlashing] = React.useState(false);
	const [img, setImg] = React.useState('/needs/vspeedOnline/sign-data/pixel_messages/0.gif');
	const [pixels, setPixels] = React.useState('000011100100000011100100010000,000100010100000100010100010000,000100000100000100010101010000,000100000100000100010101010000,000011100100000100010101010000,000000010100000100010101010000,000000010100000100010101010000,000100010100000100010101010000,000011100111110011100011100000,000111100011100100010100010000,000100010100010100010100010000,000100010100010101010110010000,000100010100010101010101010000,000100010100010101010100110000,000100010100010101010100010000,000100010100010101010100010000,000100010100010101010100010000,000111100011100011100100010000,');
	//standard is 30 x 18
	
	React.useEffect(() => {
		if(id){
			setMsgid(id);
		}
		if(path){
			setImgpath(path);
		}
		if(width && height){
			setSize([width, height]);
			if(msgid === 0 || msgid === '0'){
				setPixels(Array(height).fill('0'.repeat(width)).join(','));
			}
		}
		if(scale){
			setScaling(scale);
		}
		if(displayState === 'on'){
			setIsOn(true);
		} else if(displayState === 'off'){
			setIsOn(false);
		}
		if(msgid && imgpath){
			setImg(imgpath+msgid+'.gif');
		}
		if(pixel_map){
			setPixels(pixel_map);
			//console.log("Pixels are");
			//console.log(pixel_map);
		}
		if(timing){
			setFlashing(true);
		} else {
			setFlashing(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	React.useEffect(() => {
		if(flashing){
			setIsOn(false);
			setTimeout(() => setFlashing(false), timing.period * 1000);
			//setTimeout(() => setIsOn(true), timing.off);
		} else {
			setIsOn(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [flashing]);
	
	React.useEffect(() => {
		if(flashing){
			if(isOn){
				setTimeout(() => setIsOn(false), timing.on);
			} else {
				setTimeout(() => setIsOn(true), timing.off);
			}
		} else {
			setIsOn(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isOn]);
	
	const renderStyle = () => {
		//console.log(classes.udisplay);
		let outstyle = {
			'background-color' : '#000000',
			'background-image' : 'url('+img+')',
			'background-size' : 'contain',
			'background-repeat' : 'no-repeat',
			'background-position' : 'center',
			'width':size[0] * scaling,
			'height':((splitVertical ? splitVertical : 0) + size[1]) * scaling,
			'border': (borderSize ? borderSize : '10')+'px solid black',
			boxSizing:'content-box',
		}
		if(isOn){
			outstyle.backgroundBlendMode = 'normal';
		} else {
			outstyle.backgroundBlendMode = 'darken'
		}
		return outstyle;
		
	}
	/*
	const renderPixel = (pix, n) => {
		if(parseInt(pix) === 1){
			return (
				<rect key={n} x={n%size[0]*scale} y={Math.floor(n/size[0])*scale} width={scale} height={scale} style={{fill:parseInt(pix) === 1 ? "rgb(255, 150, 0)" : "rgb(0, 0, 0)"}} />
			);
		}
		else {
			return "";
		}
	}
	*/
	const renderPath = (map) => {
		var path = "";
		map.forEach((pix, n) => {
			if(parseInt(pix) === 1){
				path+='M'+(n%size[0]*scale)+' '+(Math.floor(n/size[0])*scale)+
					'h'+Math.ceil(scale / 2)+' '+Math.ceil(scale / 2)+
					'v'+Math.ceil(scale / 2)+' '+Math.ceil(scale / 2)+
					'h-'+Math.ceil(scale / 2)+' -'+Math.ceil(scale / 2)+'Z';
			}
		});
		return path;
	}
	const renderDisplayImage = () => {
		if(isOn){
			if(pixels){
				
				//.slice(0, size[1])
				//substr(0, size[0])
				var map = Array.from(
					pixels.split(',').filter(i=>i).slice(0, size[1]), 
					line => line.substr(0, size[0]).split(''));
				if(splitVertical){
					map.splice(size[1]/2, 0, '0'.repeat(size[0]*splitVertical).split(''));
				}
				//console.log(map);
				return (
					<svg 
						width={size[0]*scale} height={(size[1] + (splitVertical ? splitVertical : 0)) * scale}>
						<rect x={0} y={0} width={size[0]*scale} height={(size[1] +(splitVertical ? splitVertical : 0)) * scale} fill="#000" stroke="none"/>
						<path d={renderPath(map.flat())} fill="#f80" stroke="none"/>
					</svg>
				);
				/*
				return (
					<svg width={size[0]*scale} height={ (size[1] + (splitVertical ? splitVertical : 0)) * scale}>
						{map.flat().map(renderPixel)}
					</svg>
				);
				*/
			} else {
				return "";
			}
		} else {
			return "";
		}
	}
	
	

  return (
	  <div style={renderStyle()}>
	  	{renderDisplayImage()}
	  </div>
  );
}
